// src/data/menuData.js
export const menuData = {
    main: {
      title: "Main Menu",
      sections: [
        {
          title: "Departments",
          items: [
            { name: "Grinders & Crushers", key: "grinders" },
            { name: "Rolling Papers & Cones", key: "rolling" },
            { name: "Vapes & E-Juice", key: "vapes" },
            { name: "Glass Bongs & Rigs", key: "bongs" },
            { name: "Hookahs & Accessories", key: "hookah" },
            { name: "Ashtrays & Trays", key: "ashtrays" },
            { name: "Storage & Containers", key: "storage" },
          ],
        },
      ],
    },
  
    grinders: {
      title: "Grinders & Crushers",
      items: [
        { name: "Metal Grinders" },
        { name: "Acrylic Grinders" },
        { name: "Wooden Grinders" },
        { name: "Electric Grinders" },
      ],
    },
    rolling: {
      title: "Rolling Papers & Cones",
      items: [
        { name: "King Size Papers" },
        { name: "Organic Hemp Papers" },
        { name: "Pre-Rolled Cones" },
        { name: "Flavored Papers" },
      ],
    },
    vapes: {
      title: "Vapes & E-Juice",
      items: [
        { name: "Disposable Vapes" },
        { name: "Pod Systems" },
        { name: "E-Liquid Bottles" },
      ],
    },
    bongs: {
      title: "Glass Bongs & Rigs",
      items: [
        { name: "Beaker Bongs" },
        { name: "Mini Bongs" },
        { name: "Recycler Rigs" },
      ],
    },
  };
  